import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { hrAPI } from '@/lib/api';
import { toast } from 'sonner';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, GraduationCap } from 'lucide-react';
import { Toaster } from '@/components/ui/sonner';
import { TestTaker } from './TestTaker';

export default function PublicTestPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [done, setDone] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const d = (await hrAPI.publicGetTest(token)).data;
        if (d.status === 'submitted') setDone({ score: d.score, total: d.total });
        else setData(d);
      } catch (e) { setErr(e.response?.data?.detail || 'Invalid or expired link'); }
    })();
  }, [token]);

  const submit = async (answers) => {
    try { const r = await hrAPI.publicSubmitTest(token, { answers }); setDone(r.data); toast.success('Submitted'); }
    catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
  };

  return (
    <div className="min-h-screen bg-slate-50 py-8 px-4">
      <Toaster position="top-right" richColors />
      <div className="max-w-2xl mx-auto mb-4 flex items-center gap-2 text-slate-700"><GraduationCap className="w-5 h-5 text-pink-600" /><span className="font-semibold">BHPL — Competency Test</span></div>
      {done ? (
        <Card className="max-w-md mx-auto border-slate-200"><CardContent className="p-8 text-center" data-testid="public-test-done"><CheckCircle className="w-12 h-12 text-emerald-500 mx-auto mb-3" /><h1 className="text-xl font-bold">Thank you!</h1><p className="text-slate-600 mt-1">Your test has been submitted.</p><p className="text-slate-600 mt-1">Score: <b>{done.score}/{done.total}</b></p></CardContent></Card>
      ) : err ? (
        <Card className="max-w-md mx-auto border-slate-200"><CardContent className="p-8 text-center"><p className="text-sm text-red-600">{err}</p></CardContent></Card>
      ) : !data ? (
        <p className="text-center text-slate-400 py-10 text-sm">Loading test...</p>
      ) : (
        <TestTaker title={data.name} taker={data.taker_name} questions={data.questions} timeLimitMin={data.time_limit_min} onSubmit={submit} />
      )}
    </div>
  );
}
